<template>
  <ul class="content-approval-menu">
      <li v-for="tab in sideBarData.tabs" :key="tab.name"
          class="content-approval-item" :class="{active: panelRoute === tab.routeName}">
          <div v-if="showTab(tab.permissionTypesVisableFor)"  @click="goToRoute(tab.routeName)" class="tab-clickable-area">
          <figure class="item">
            <img :src="getImageSrc(tab.routeName)" class="icon" alt="">
            <figcaption class="caption">{{ $t(tab.textOnTab) }}</figcaption>
          </figure>
          </div>
      </li>
  </ul>
</template>

<script>
import { mapState } from 'vuex'
import { sideBarData } from '@/constants'

export default {
  name: 'library-sidebar',
  data () {
    return {
      sideBarData
    }
  },
  computed: {
    ...mapState({
      userRoles: state => state.base.userRoles,
      panelRoute: state => state.base.panelRoute
    })
  },
  methods: {
    goToRoute (selectedRoute) {
      return this.$store.dispatch('resetFilterAndSearch').then(() => {
        this.$router.push({ name: selectedRoute })
      })
    },
    showTab (typesCanSeeTab) {
      for (const type of typesCanSeeTab) {
        if (this.userRoles?.includes(type)) {
          return true
        }
      }
      return false
    },
    getImageSrc (tabName) {
      return require('@/assets/images/team-panel/sidebar/' + tabName + '.svg')
    }
  }
}
</script>

<style >
.tab-clickable-area{
  width: 100%;
  height: 100%;
}
</style>
